import { EChatModalActionType, TOpenChatModalPayload, TSetOpenAfterAuthPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const openChatModal = actionGenerator<EChatModalActionType.Open, TOpenChatModalPayload>(
  EChatModalActionType.Open,
);
export const closeChatModal = actionGenerator<EChatModalActionType.Close>(EChatModalActionType.Close);
export const setOpenChatModalAfterAuth = actionGenerator<
  EChatModalActionType.SetOpenAfterAuth,
  TSetOpenAfterAuthPayload
>(EChatModalActionType.SetOpenAfterAuth);
